import { render, staticRenderFns } from "./CreateBarcode.vue?vue&type=template&id=04142f8e"
import script from "./CreateBarcode.vue?vue&type=script&lang=js"
export * from "./CreateBarcode.vue?vue&type=script&lang=js"
import style0 from "./CreateBarcode.vue?vue&type=style&index=0&id=04142f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports